import dayjs, { Dayjs } from 'dayjs'

const CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/

/**
 * Calendar day from the picker. Use format(), not valueOf(): after a clear,
 * choosing 2027-01-01 in Chicago yields 1798779600000 (2026-12-31 23:00)
 * while format() is still 2027-01-01.
 */
export function toCalendarDate(value: Dayjs | number | string): string {
  if (typeof value === 'string' && CALENDAR_DATE.test(value)) {
    return value
  }
  if (
    value &&
    typeof value === 'object' &&
    typeof (value as Dayjs).format === 'function'
  ) {
    return (value as Dayjs).format('YYYY-MM-DD')
  }
  return dayjs(value).format('YYYY-MM-DD')
}
